import React from 'react';
import { Share, PlusSquare, X, Smartphone, Apple, Chrome, CheckCircle2 } from 'lucide-react';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const PwaTipModal: React.FC<Props> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-md animate-fade-in">
      <div className="bg-slate-900 border border-slate-800 w-full max-w-md rounded-3xl overflow-hidden shadow-2xl relative">
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 p-2 text-slate-400 hover:text-white transition-colors"
        >
          <X size={24} />
        </button>

        <div className="p-8 space-y-6">
          <div className="text-center space-y-2">
            <div className="w-16 h-16 bg-orange-600/20 rounded-2xl flex items-center justify-center mx-auto text-orange-500">
              <Smartphone size={32} />
            </div>
            <h2 className="text-2xl font-black text-white">Dica de Mestre! 🏆</h2>
            <p className="text-slate-400">Instale o app na sua tela inicial para acesso instantâneo e mais espaço na tela.</p>
          </div>

          <div className="space-y-4">
            <div className="bg-slate-800/50 p-6 rounded-2xl border border-slate-700/50 space-y-4">
              <h3 className="flex items-center gap-2 text-white font-bold">
                {isIOS ? <Apple size={18} className="text-slate-400" /> : <Chrome size={18} className="text-slate-400" />}
                Como Instalar:
              </h3>
              
              {isIOS ? (
                <div className="space-y-4 text-sm text-slate-300">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-xs font-bold">1</div>
                    <p>Toque no botão <span className="inline-flex items-center text-blue-400 font-bold"><Share size={14} className="mx-1" /> Compartilhar</span></p>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-xs font-bold">2</div>
                    <p>Role para baixo e selecione <br/><span className="text-white font-bold flex items-center gap-1"><PlusSquare size={14} /> Adicionar à Tela de Início</span></p>
                  </div>
                </div>
              ) : (
                <div className="space-y-4 text-sm text-slate-300">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-xs font-bold">1</div>
                    <p>Toque nos <span className="text-white font-bold">três pontinhos (⋮)</span> do Chrome</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center text-xs font-bold">2</div>
                    <p>Selecione <span className="text-white font-bold italic">"Instalar Aplicativo"</span> ou <span className="text-white font-bold italic">"Adicionar à tela inicial"</span></p>
                  </div>
                </div>
              )}
            </div>

            <div className="flex items-center gap-3 p-4 bg-green-500/10 rounded-xl border border-green-500/20 text-green-500 text-xs">
              <CheckCircle2 size={16} />
              <span>O app ocupará menos memória e funcionará como um app oficial!</span>
            </div>
          </div>

          <button
            onClick={onClose}
            className="w-full py-4 bg-orange-600 hover:bg-orange-500 text-white font-black rounded-2xl shadow-lg transition-all active:scale-95"
          >
            Entendido!
          </button>
        </div>
      </div>
    </div>
  );
};
